const layoutTypes = {
    ITEM_DEFAULT_START: 'ITEM_DEFAULT_START',
    ITEM_DEFAULT_SUCCESS: 'ITEM_DEFAULT_SUCCESS',
    ITEM_WHITE_START: 'ITEM_WHITE_START',
    ITEM_WHITE_SUCCESS: 'ITEM_WHITE_SUCCESS',
    ITEM_BLACK_START: 'ITEM_BLACK_START',
    ITEM_BLACK_SUCCESS: 'ITEM_BLACK_SUCCESS',
}

export default layoutTypes